import React, { useState } from 'react';
import { string, bool } from 'prop-types';

import Close from '@material-ui/icons/Close';
import Add from '@material-ui/icons/Add';
import * as styles from './styles/styles.module.scss';

// todo: we already have a very similar component, 'collapsible' but it does not use CSS Modules and it's in the old components directory.
//       Leaving this todo here to remember to replace references to 'collapsible' in the converter with this Expandable component.
const Expandable = ({ title, collapsed, classes, children }) => {
  const [isCollapsed, toggleIsCollapsed] = useState(collapsed || true);

  const toggleContent = () => {
    toggleIsCollapsed(prevState => !prevState);
  };

  return (
    <div className={`${styles.container} ${classes}`}>
      <div onClick={toggleContent} className={styles.control}>
        <div className={styles.title}>{title}</div>
        <div className={styles.toggleButton}>{isCollapsed ? <Add /> : <Close />}</div>
      </div>
      <div className={`${isCollapsed ? styles.collapsed : styles.collapsible}`}>{children}</div>
    </div>
  );
};

Expandable.propTypes = {
  title: string,
  collapsed: bool,
  classes: string
};

Expandable.defaultProps = {
  title: '',
  collapsed: true,
  classes: ''
};

export default Expandable;
